











































































import Vue from 'vue';
import { mapActions } from 'vuex';
import Component from 'vue-class-component';

import { mdiChevronRight } from '@mdi/js';

const Props = Vue.extend({
	props: {
		code: {
			type: String,
			default: undefined
		},
		codeMessage: {
			type: String,
			default: undefined
		},
		title: {
			type: String,
			required: true
		},
		message: {
			type: String,
			default: undefined
		},
		messageError: {
			type: String,
			default: undefined
		},
		backBtnText: {
			type: String,
			default: undefined
		},
		image: {
			type: String,
			default: 'erreur-404.png'
		},
		metaTitle: {
			type: String,
			default: 'Erreur 404'
		},
		metaContent: {
			type: String,
			default: 'Ressource non trouvée.'
		}
	},
	methods: {
		...mapActions('globalState', ['resetLoading'])
	}
});

@Component
export default class ErrorPage extends Props {

	chevronRight = mdiChevronRight;

	redirect(): void {
		if (this.$cookies.keys().includes('ep-origin')) {
			window.location.replace(this.$cookies.get('ep-origin'));
		}
	}

	created() {
		this.resetLoading();
	}
}
